module.exports = __webpack_public_path__ + "img/course (3).b94ab1a7.png";